import { PricingSheetRow } from "../types";
import { isRentalHistoryRow } from "./isRentalHistoryRow";

export const containsRentalHistoryRows = (
  pricingSheetRows: PricingSheetRow[],
) => {
  return pricingSheetRows.some(isRentalHistoryRow);
};
